class FostrCartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const isGift = this.dataset.isGift
      const cartItems = this.closest('fostr-cart-items') || this.closest('fostr-cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, 'minus', isGift);
    });
  }
}

customElements.define('fostr-cart-remove-button', FostrCartRemoveButton);

class FostrCartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
    this.gwp = document.querySelector('fostr-gwp');

    const upsell_swiper = new Swiper('.cart-drawer-upsell', {
      slidesPerView: 1.5,
      autoHeight: true,
      spaceBetween: 20,
      grabCursor: true,
      effect: 'slide',
      direction: 'horizontal',
      loop: true,
      clickable: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      }
    });
    window.initGwpCarousel && window.initGwpCarousel();

  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'fostr-main-cart-items',
        section: document.getElementById('fostr-main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'fostr-cart-icon-bubble',
        section: 'fostr-cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'fostr-cart-live-region-text',
        section: 'fostr-cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'fostr-main-cart-footer',
        section: document.getElementById('fostr-main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  renderContents(parsedState, animateInClass) {
    if (!parsedState.sections) {
      return console.error('No sections in state', parsedState);
    }

    this.getSectionsToRender().forEach(section => {
      const elementToReplace =
        document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);

      if (!elementToReplace) {
        return;
      }

      elementToReplace.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.section], section.selector, animateInClass);

      elementToReplace.querySelectorAll('.hide-to-animate').forEach(el => {
        el.classList.add('fade-in');
        el.addEventListener('animationend', () => {
          el.classList.remove('fade-in');
        }, { once: true });
        window.requestAnimationFrame(() => el.classList.remove('hide-to-animate'));
      });
    });

    let cartAdditionalData = document.querySelector('.fostr-cart-additional-data');
    const sessionCartAdditionalData = sessionStorage.getItem('fostr-cart-additional');

    if(cartAdditionalData && sessionCartAdditionalData){
      cartAdditionalData.innerHTML = sessionCartAdditionalData;
    }

    this.updateEmptyState(parsedState);
    this.updateUpsells();
    window.initGwpCarousel && window.initGwpCarousel();
  }

  updateUpsells() {
    upsell_swiper.upddate();
  }

  updateQuantity(line, quantity, name, isGift = false) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.gwp.init();

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('fostr-cart-drawer');
        const cartFooter = document.getElementById('fostr-main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          if (section.hasOwnProperty('selectors')) {
              const selector = section.selectors;
              const elementToReplace = document.querySelector(selector);
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], selector);

          } else {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }
        }));

        if(!isGift) this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }

        this.disableLoading();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('fostr-cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('fostr-main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('fostr-main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('fostr-cart-items', FostrCartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  });
}
